<!--Создаёт два контейнера для вмещения в себя списка МО по их типу-->
<template>
  <v-container grid-list-md text-xs-center style="max-width: fit-content">
    <v-layout v-if="isLoading === false" row wrap>
      <v-flex lg7 md12 sm12 xs12>
        <regions-once-type :regions = "this.districtsList">
          Муниципальные районы
        </regions-once-type>
      </v-flex>
      <v-flex lg5 md12 sm12 xs12>
        <regions-once-type :regions = "this.citiesList">
          Городские округа
        </regions-once-type>
      </v-flex>
    </v-layout>
    <v-layout v-else>
      <vue-simple-spinner style="margin-top: 300px;" line-fg-color="#3f51b5" size="big"  />
    </v-layout>

  </v-container>
</template>

<script>
import RegionsSelectedOnceType from "@/components/regions-selected-once-type";
import axios from "axios";
import Spinner from "vue-simple-spinner/src/components/Spinner";

export default {
  data() {
    return {
      municipality: [],
      citiesList: [],
      isLoading: true,
      districtsList: []
    }
  },
  components: {
    "vue-simple-spinner": Spinner,
    "regions-once-type": RegionsSelectedOnceType
  },
  name: "choose-region",
  methods: {
    loadMunicipality() {
      this.isLoading = true
      axios
        .post("/eco-passport/get-municipality")
        .then(response => {
          this.municipality = response.data
          this.districtsList = this.municipality.districts
          this.citiesList = this.municipality.cities
          this.isLoading = false
        })
        .catch(e => alert(e.toString()));
    }
  },
  created() {
    this.loadMunicipality()
  }
}
</script>

<style scoped>

</style>